<div class="hidden table-container" [class.show]="dataSource.busyMonitor.isBusy">
    <table mat-table matSort #skeletonTable [dataSource]="skeletonDataSource">
        <ng-template #skeletonTemplateRef>
            <td class="mat-cell cdk-cell">
                <div class="skeleton-cell"></div>
            </td>
        </ng-template>
        <ng-template #skeletonHeaderTemplateRef>
            <th class="mat-header-cell cdk-header-cell">
                <div class="skeleton-cell"></div>
            </th>
        </ng-template>
        <ng-template #skeletonFooterTemplateRef> </ng-template>
        <tr mat-header-row *matHeaderRowDef="skeletonDisplayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: skeletonDisplayedColumns"></tr>
    </table>
</div>

<div class="no-data" *ngIf="!dataSource.busyMonitor.isBusy && dataSource.isEmpty">
    <mat-icon>search_off</mat-icon>
    <div i18n="@@NoResultsHere">No results here</div>
</div>

<!--cannot ngIf here - the component needs to find ContentChildren / ViewChildren -->
<div class="hidden table-container" [class.show]="!dataSource.busyMonitor.isBusy && !dataSource.isEmpty">
    <table mat-table multiTemplateDataRows #table [dataSource]="dataSource">
        <!-- isSelected column -->
        <ng-container matColumnDef="isSelected">
            <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
                <ng-template [ngTemplateOutlet]="headerSelectionCheckboxTemplate"></ng-template>
            </th>
            <td mat-cell *matCellDef="let element" class="checkbox-cell">
                <mat-checkbox
                    (click)="onSelectionClicked($event)"
                    (change)="onSelectionChanged(element)"
                    [checked]="element._isSelected"
                    class="checkbox"
                >
                </mat-checkbox>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick($event, row)"
            [class.table-active]="row._isSelected"
            [class.actionable]="rowClick.observers.length > 0"
            [class.read]="isReadSelector && isReadSelector(row)"
            [class.archived]="isArchivedSelector && isArchivedSelector(row)"
        ></tr>
    </table>

    <div *ngIf="showPaginator">
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="dataSource.totalCount" showFirstLastButtons></mat-paginator>
    </div>
    <div *ngIf="!showPaginator && dataSource.totalCount > 0" class="counters">
        {{ dataSource.loadedCount }}
        <ng-container i18n="@@of">of</ng-container>
        {{ dataSource.totalCount }}
        <ng-container i18n="@@items">items</ng-container>
    </div>

    <ng-template #headerSelectionCheckboxTemplate>
        <mat-checkbox
            (click)="onSelectionClicked($event)"
            (change)="toggleSelectAll()"
            [checked]="selectionService.isAllSelected"
            [indeterminate]="selectionService.isAnySelected"
        >
        </mat-checkbox>
    </ng-template>
</div>
